import React from "react";
import PropTypes from "prop-types";
import Divider from "@material-ui/core/Divider";
import FieldToggle from "../../FieldToggle";
import SplitToggles from "../SplitToggles";
import style from "./style";

export default class EntityPermissionsToggles extends React.Component {
  handleChange({name, value}) {
    const path = ["permissions", ...name.split(".")];
    this.setState({
      touched: true,
      permission: this.state.permission.setIn(path, value)
    });
  }

  handleToggleAll({name, value}) {
    const {options, toggleAll} = this.props;
    toggleAll({
      name,
      value: {
        toggle: value,
        value: options.map(category => category._id)
      }
    });
  }

  getToggleState() {
    let {toggleState, entityArray, options} = this.props;
    if (typeof toggleState === "undefined" && entityArray) {
      toggleState = entityArray.length && entityArray.length === options.length;
    }

    return !!toggleState;
  }

  render() {
    const {options, title, entityName, entityArray, disabled, divider, onChange, toggleName} = this.props;

    let toggleState = this.getToggleState();

    return (
      <div className={this.props.className} style={this.props.style}>
        <div style={{marginBottom: "10px"}}>
          {title ? <h3 style={{display: "inline-block"}}>{title}</h3> : null}
          <FieldToggle
            name={entityName}
            value={toggleState}
            onChange={this.handleToggleAll.bind(this)}
            style={style.toggleAllSwitch}
            label={toggleName || "Toggle All"}
            toggled={toggleState}
            disabled={disabled}
          />
        </div>
        {divider ? <Divider /> : null}
        <div style={{marginLeft: 42, marginBottom: 24}}>
          <div style={{marginTop: "10px"}}>
            <SplitToggles
              cols={2}
              name={entityName}
              items={options}
              selectedItems={entityArray}
              onChange={onChange}
              disabled={disabled}
            />
          </div>
        </div>
      </div>
    );
  }
}

EntityPermissionsToggles.propTypes = {
  options: PropTypes.array,
  title: PropTypes.string,
  entityName: PropTypes.string,
  entityArray: PropTypes.array,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  toggleAll: PropTypes.func,
  divider: PropTypes.bool
};

EntityPermissionsToggles.defaultProps = {
  divider: true
};



// WEBPACK FOOTER //
// ./src/components/PermissionsToggles/EntityPermissions/index.jsx